module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span-1-lg offset-2-lg span-1-md hide-sm"
  }, [_c('div', {
    staticClass: "p subheader survey-number transition-1"
  }, [_vm._v(_vm._s(_vm.ind) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "span-10-lg span-14-md span-14-sm offset-1-sm span-14-xs offset-1-xs "
  }, [_c('p', {
    staticClass: "large border-error-container"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed0024fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/surveyCaption.vue
// module id = 671
// module chunks = 1